import fivestar from '../assets/fivestar.png';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';

function Section5() {
  return (
    <div className="pb-10 md:pb-20 text-black bg-gray-100 relative">
      <div className="hidden lg:block absolute right-0 top-0">
        <div className="bg-[#FD6721] h-[40rem] w-[30rem] z-0 rounded-l-full"></div>
      </div>
      <div>
        <p className="font-bold text-4xl md:text-5xl text-center pt-10 mb-3">
          Our <span className="text-blue-600">Reviews</span>
        </p>
        <hr className="border-1 border-[#0098D1] w-20 mx-auto rounded-md" />
      </div>
      <div className="flex flex-col lg:flex-row w-full h-[950px] lg:h-[350px] mt-8 lg:mt-14">
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:ml-32 2xl:ml-80 p-5 shadow-[#0098D1] shadow-md overflow-auto">
          <p className="font-medium text-xl mb-5">Robert G.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "Top-notch experience with Optimal Temp. Scheduling was easy,
            communication was clear, and the work was completed exactly as
            promised. Robert and his team were courteous, efficient, and clearly
            knew what they were doing. Everything was explained in plain terms,
            and the system has been working flawlessly since installation"
          </p>
        </div>
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:mx-8 p-5 mt-8 lg:mt-0 shadow-[#0098D1] shadow-md overflow-auto z-10">
          <p className="font-medium text-xl mb-5">Gabriel G.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "Very happy with the service from Optimal Temp. The technician
            arrived on time, walked me through my options, and delivered quality
            work without any hassle. The pricing was reasonable and there was no
            pressure at any point. Professional company that stands behind their
            work"
          </p>
        </div>
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:mr-32 2xl:mr-80 z-10 p-5 mt-8 lg:mt-0 shadow-[#0098D1] shadow-md overflow-auto">
          <p className="font-medium text-xl mb-5">George F.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "Optimal Temp did an excellent job from start to finish. The crew
            was respectful of my home and business, worked quickly, and kept
            everything clean. They explained the process clearly and made sure
            the system was running properly before leaving. I’ve already noticed
            an improvement in comfort"
          </p>
        </div>
      </div>
      <div className="flex justify-center mt-10">
        <HashLink
          to="/#Contact"
          className="bg-[#FD6721] rounded-sm text-white px-6 py-3 shadow-black shadow-sm hover:bg-blue-600"
        >
          Get In Touch
        </HashLink>
      </div>
    </div>
  );
}

export default Section5;
